import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MapView from '@/pages/MapView';
import AdminPanel from '@/pages/AdminPanel';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MapView />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
